/**
 * Klaviyo reviews widgets — two small fixes the app's own settings can't do.
 *
 * 1. "All reviews" summary → link. On the homepage and landing pages the Klaviyo all-reviews app block renders
 * only its summary ("4.9 / 5 · 1267 reviews"); the review list underneath is
 * hidden, so there is nothing to click. Klaviyo builds the widget client-side,
 * so we wait for it, and where the list is hidden we make the summary a link
 * to /pages/reviews (the full list) and add a visible "Read all … reviews"
 * caption. Pages that show the list (the reviews page itself) are untouched.
 */
(function () {
  var REVIEWS_PAGE = '/pages/reviews';
  var LINK_CLASS = 'reviews-summary-link';

  function enhance(widget) {
    if (widget.classList.contains(LINK_CLASS)) return;
    var summary = widget.querySelector('.kl_reviews__summary');
    var list = widget.querySelector('.kl_reviews__reviews_list');
    if (!summary || !list) return;
    if (getComputedStyle(list).display !== 'none') return;

    widget.classList.add(LINK_CLASS);

    var countEl = widget.querySelector('.kl_reviews__summary__stars__count');
    var count = countEl ? countEl.textContent.trim() : '';
    var cta = document.createElement('a');
    cta.className = LINK_CLASS + '__cta';
    cta.href = REVIEWS_PAGE;
    cta.textContent = count ? 'Read all ' + count : 'Read all reviews';
    summary.appendChild(cta);

    summary.addEventListener('click', function (event) {
      if (event.target.closest('a')) return; // the caption is a real link already
      window.location.href = REVIEWS_PAGE;
    });
  }

  // Klaviyo mounts the widget, then hides the list by flipping a class/style,
  // so watch attribute changes as well as added nodes. Scans are cheap (one
  // id lookup) and coalesced per frame; the observer stops once the summary
  // has been linked.
  // 2. Featured-reviews carousel: three cards per view on desktop. Klaviyo's
  // slider config hard-codes two above 900px and exposes no setting for it,
  // so adjust the live Swiper instance once it exists. Breakpoint params are
  // re-read on resize, so the change sticks.
  var DESKTOP_SLIDES = 3;
  var DESKTOP_GAP = 16;
  var carouselDone = false;
  function widenCarousel() {
    var root = document.getElementById('klaviyo-featured-reviews-carousel');
    var swiperEl = root && root.querySelector('.swiper');
    var swiper = swiperEl && swiperEl.swiper;
    if (!swiper || !swiper.params) return;
    var bp = swiper.params.breakpoints || {};
    Object.keys(bp).forEach(function (key) {
      if (Number(key) >= 900) {
        bp[key].slidesPerView = DESKTOP_SLIDES;
        bp[key].spaceBetween = DESKTOP_GAP;
      }
    });
    if (window.innerWidth >= 900) {
      swiper.params.slidesPerView = DESKTOP_SLIDES;
      swiper.params.spaceBetween = DESKTOP_GAP;
    }
    swiper.update();
    carouselDone = true;
  }

  var scheduled = false;
  var observer = new MutationObserver(schedule);
  function scan() {
    scheduled = false;
    var summary = document.getElementById('klaviyo-reviews-all');
    if (summary) enhance(summary);
    if (!carouselDone) widenCarousel();
    var summaryDone = !summary || summary.classList.contains(LINK_CLASS);
    if (summaryDone && carouselDone) observer.disconnect();
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    // setTimeout rather than requestAnimationFrame: rAF is paused in
    // background tabs, which would leave a tab opened in the background unlinked.
    window.setTimeout(scan, 50);
  }

  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
  schedule();
})();
